
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 16V7.9l-2.6 2.5L3.5 9l5-5 5 5-1.4 1.4-2.6-2.6V16zM.5 5V2q0-.8.6-1.4A2 2 0 012.5 0h12q.8 0 1.4.6t.6 1.4v3h-2V2h-12v3z","fill":"#fff"}})])
          )
        }
      }
    